/* eslint-disable import/no-extraneous-dependencies */

import Admin from '../../components/Admin';

import getFilterWithCol from '../../helpers/getFilterWithCol';

const isNotStats = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'STATS',
]);

export default [
  getFilterWithCol(['FieldSortableList', {
    name: 'stats_items',
    label: null,
    addButtonLabel: 'Add Item',
    supportDuplicate: true,
    fields: [
      getFilterWithCol(['FieldText', {
        name: 'title',
        label: null,
        prefix: 'Title:',
      }], 12),
      getFilterWithCol(['FieldText', {
        name: 'subtitle',
        label: null,
        prefix: 'Subtitle:',
      }], 12),
      getFilterWithCol(['FieldText', {
        name: 'value',
        label: null,
        prefix: 'Value:',
      }], 24),
    ],
  }]),
].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
  fieldType,
  { ...fieldConfig, skip: [isNotStats, ...(fieldConfig.skip || [])] },
]));
